import React from "react";

export default function Government() {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="80" height="80" rx="40" fill="#FACFB0" />
      <path
        d="M61 61.2917C62.1276 61.2917 63.0417 62.2058 63.0417 63.3333C63.0416 64.4609 62.1276 65.375 61 65.375H19C17.8724 65.375 16.9584 64.4609 16.9583 63.3333C16.9583 62.2058 17.8724 61.2917 19 61.2917H61Z"
        fill="#122A36"
      />
      <path
        d="M26 35.625C27.1276 35.625 28.0417 36.5391 28.0417 37.6667V54C28.0416 55.1276 27.1276 56.0417 26 56.0417C24.8724 56.0417 23.9584 55.1276 23.9583 54V37.6667C23.9583 36.5391 24.8724 35.625 26 35.625Z"
        fill="#122A36"
      />
      <path
        d="M35.3333 35.625C36.4609 35.625 37.375 36.5391 37.375 37.6667V54C37.375 55.1276 36.4609 56.0417 35.3333 56.0417C34.2058 56.0417 33.2917 55.1276 33.2917 54V37.6667C33.2917 36.5391 34.2057 35.625 35.3333 35.625Z"
        fill="#122A36"
      />
      <path
        d="M44.6667 35.625C45.7942 35.625 46.7083 36.5391 46.7083 37.6667V54C46.7083 55.1276 45.7942 56.0417 44.6667 56.0417C43.5391 56.0417 42.625 55.1276 42.625 54V37.6667C42.625 36.5391 43.5391 35.625 44.6667 35.625Z"
        fill="#122A36"
      />
      <path
        d="M54 35.625C55.1276 35.625 56.0417 36.5391 56.0417 37.6667V54C56.0416 55.1276 55.1276 56.0417 54 56.0417C52.8724 56.0417 51.9584 55.1276 51.9583 54V37.6667C51.9583 36.5391 52.8724 35.625 54 35.625Z"
        fill="#122A36"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M39.1728 14.8005C39.7865 14.5283 40.5027 14.5726 41.0824 14.9349L59.749 26.6016C60.5214 27.0843 60.8797 28.0207 60.6286 28.8962C60.3774 29.7716 59.5774 30.375 58.6667 30.375H21.3333C20.4226 30.375 19.6226 29.7716 19.3714 28.8962C19.1203 28.0207 19.4786 27.0843 20.251 26.6016L38.9176 14.9349L39.1728 14.8005ZM28.4541 26.2917H51.5459L40 19.0729L28.4541 26.2917Z"
        fill="#122A36"
      />
    </svg>
  );
}